import React, { useEffect, useState } from "react";
import { Typography, Form, Select, Input, Row, Col, message } from "antd";
import { DomainApi } from "../../services/DomainApi";
import { ClientApi } from "../../services/ClientApi";
import { EngagementApi } from "../../services/EngagementApi";
import { useAxios } from "../../contexts/AxiosProvider";

const { Option } = Select;

const AddWorkflow = ({
  user_id,
  open,
  addWorkflowData,
  setAddWorkflowData,
}) => {
  const axios = useAxios();
  const [loading, setLoading] = useState(false);
  const [domainData, setDomainData] = useState({
    domainList: [],
    totalDomains: 0,
  });
  const [clientData, setClientData] = useState({
    clientList: [],
    totalClients: 0,
  });
  const [engagementData, setEngagementData] = useState({
    engagementList: [],
    totalEngagements: 0,
  });

  const fetchAllDomains = async () => {
    try {
      setLoading(true);
      const data = {
        user_id: user_id,
        search: false,
        domainSearchParam: "",
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await DomainApi.getAllDomains(axios, data);
      if (response.status === 200) {
        setDomainData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        message.error("500 Internal Server Error!");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchAllDomains();
    }
  }, [open]);

  const fetchAllClients = async (domain_id) => {
    try {
      setLoading(true);
      const data = {
        user_id: user_id,
        domain: true,
        domain_id: domain_id,
        search: false,
        searchParam: "",
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await ClientApi.getAllClients(axios, data);
      if (response.status === 200) {
        setClientData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        message.error("500 Internal Server Error!");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (addWorkflowData.domain.domain_id) {
      fetchAllClients(addWorkflowData.domain.domain_id);
    }
  }, [addWorkflowData.domain.domain_id]);

  const fetchAllEngagements = async (client_id) => {
    try {
      setLoading(true);
      const data = {
        user_id: user_id,
        client: true,
        client_id: client_id,
        search: false,
        searchParam: "",
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await EngagementApi.getAllEngagements(axios, data);
      if (response.status === 200) {
        setEngagementData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        message.error("500 Internal Server Error!");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (addWorkflowData.client.client_id) {
      fetchAllEngagements(addWorkflowData.client.client_id);
    }
  }, [addWorkflowData.client.client_id]);

  const handleChange = (name, value) => {
    if (name === "domain") {
      setAddWorkflowData({
        ...addWorkflowData,
        domain: {
          ...addWorkflowData.domain,
          domain_name: value,
          domain_id:
            domainData.domainList.find((item) => item.domain_name === value)
              ?.domain_id || "",
        },
      });
    } else if (name === "client") {
      setAddWorkflowData({
        ...addWorkflowData,
        client: {
          ...addWorkflowData.client,
          client_name: value,
          client_id:
            clientData.clientList.find((item) => item.client_name === value)
              ?.client_id || "",
        },
      });
    } else if (name === "engagement") {
      setAddWorkflowData({
        ...addWorkflowData,
        engagement: {
          ...addWorkflowData.engagement,
          engagement_name: value,
          engagement_id:
            engagementData.engagementList.find(
              (item) => item.engagement_name === value
            )?.engagement_id || "",
        },
      });
    } else {
      setAddWorkflowData({ ...addWorkflowData, [name]: value });
    }
  };

  return (
    <Form layout="vertical">
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label={
              <Typography.Text style={{ color: "#8798AD", fontSize: "11px" }}>
                Function*
              </Typography.Text>
            }
            required
          >
            <Select
              value={addWorkflowData.domain.domain_name}
              onChange={(value) => handleChange("domain", value)}
              style={{ backgroundColor: "#2E5BFF14", height: "40px" }}
            >
              {domainData.domainList?.map(
                (item) =>
                  item.status === "approved" && (
                    <Option key={item.domain_name} value={item.domain_name}>
                      {item.domain_name}
                    </Option>
                  )
              )}
            </Select>
          </Form.Item>
        </Col>
        {addWorkflowData.domain.domain_name && (
          <Col span={8}>
            <Form.Item
              label={
                <Typography.Text style={{ color: "#8798AD", fontSize: "11px" }}>
                  Sub-Function*
                </Typography.Text>
              }
              required
            >
              <Select
                value={addWorkflowData.client.client_name}
                onChange={(value) => handleChange("client", value)}
                style={{ backgroundColor: "#2E5BFF14", height: "40px" }}
              >
                {clientData.clientList?.map(
                  (item) =>
                    item.status === "approved" && (
                      <Option key={item.client_name} value={item.client_name}>
     {item.client_name}
                      </Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
        )}
        {addWorkflowData.client.client_name && (
          <Col span={8}>
            <Form.Item
              label={
                <Typography.Text style={{ color: "#8798AD", fontSize: "11px" }}>
                  Pipeline*
                </Typography.Text>
              }
              required
            >
              <Select
                value={addWorkflowData.engagement.engagement_name}
                onChange={(value) => handleChange("engagement", value)}
                style={{ backgroundColor: "#2E5BFF14", height: "40px" }}
              >
                {engagementData.engagementList?.map(
                  (item) =>
                    item.status === "approved" && (
                      <Option
                        key={item.engagement_name}
                        value={item.engagement_name}
                      >
                        {item.engagement_name}
                      </Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
        )}
        {addWorkflowData.engagement.engagement_name && (
          <Col span={24}>
            <Form.Item
              label={
                <Typography.Text style={{ color: "#8798AD", fontSize: "11px" }}>
                  Workflow*
                </Typography.Text>
              }
              required
            >
              <Input
                value={addWorkflowData.workflowName}
                onChange={(e) => handleChange("workflowName", e.target.value)}
                style={{ backgroundColor: "#2E5BFF14" }}
              />
            </Form.Item>
          </Col>
        )}
        {addWorkflowData.workflowName && (
          <Col span={24}>
            <Form.Item
              label={
                <Typography.Text style={{ color: "#8798AD", fontSize: "11px" }}>
                  Process Type*
                </Typography.Text>
              }
              required
            >
              <Select
                value={addWorkflowData.processType}
                onChange={(value) => handleChange("processType", value)}
                style={{ backgroundColor: "#2E5BFF14", height: "40px" }}
              >
                <Option value="data-ingestion">Data Ingestion</Option>
                <Option value="data-transformation">Data Transformation</Option>
                {/* <Option value="data-quality">Data Quality</Option> */}
              </Select>
            </Form.Item>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default AddWorkflow;
